import { createContext } from 'react'

import { type AllStepsData } from '../steps/AllStepsData'

type FormStepContext = { onCompleted(formData: AllStepsData): void }

export const FormStepContext = createContext<FormStepContext | null>(null)
